export default "__VITE_ASSET__9feba234__"